import { MergeSettingsState } from './types';

export const INITIAL_STATE: () => MergeSettingsState = () => {
  return {
    deleteIntegrationModalOpen: false,
  };
};
